import * as React from 'react';

import {Button} from 'shells/button/button';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import {ConnectionNextSteps} from '../../../connection-next-steps/connection-next-steps';

import WeHaveLiftoffSVG from '../assets/we-have-liftoff.svg';
import {trackModalPageLoad} from '../track-page-load';

type Props = {
    onGoToSettings: () => void;
    onGoToContacts: () => void;
    currentUrl: string;
    createPeopleOnInitialSync: boolean;
};

export function Done(props: Props) {
    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Great job! You’re all set up</ModalHeader>
                <ModalSubheader>
                    You can now send emails from inside of Nutshell and sync replies from your
                    contacts automatically.
                </ModalSubheader>
                {NutClientConfig.hasImprovedEmailCalendarSyncFF ? (
                    <ConnectionNextSteps />
                ) : (
                    <div className='flex align-center justify-center pad-16'>
                        <WeHaveLiftoffSVG />
                    </div>
                )}
            </ModalMain>
            <NavButtons>
                <React.Fragment>
                    {/* We can't just use react-router links here, because we're inside a hashrouter. */}
                    <Button variant='text' onClick={props.onGoToSettings}>
                        Review your settings
                    </Button>
                    {props.createPeopleOnInitialSync && (
                        <Button variant='primary' size='big' onClick={props.onGoToContacts}>
                            View your synced people
                        </Button>
                    )}
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
